import * as THREE from "three"
import { useFrame } from "@react-three/fiber"
import { useRef, Suspense } from "react"
import { pinPosition } from "../util"
import RoundedGlass from "../3d/RoundedGlass"
import GeoBRLC from "../3d/LogoBRLCGeo"
import Hands from "../3d/Hands"
import useStore from "../AppStore"
import PlanetOne from "../3d/PlanetOne"
import PlanetTwo from "../3d/PlanetTwo"
import PlanetThree from "../3d/PlanetThree"

export default function SceneLogo(props) {
  
  const groupRef = useRef(null)
  const glassRef = useRef(null)
  const logoRef = useRef(null)
  const planetsRef = useRef(null)
  const planets2Ref = useRef(null)
  const planets3Ref = useRef(null)
  
  useFrame(({clock}) => {
    const top = useStore.getState().top
    glassRef.current.rotation.x = Math.PI * -0.3 + top * 0.0015
    glassRef.current.rotation.y = 0.5 - top * 0.007 - clock.elapsedTime * 0.8
    logoRef.current.rotation.y = -top*0.002 + 1
    
    planetsRef.current.rotation.y = -top * 0.005 - clock.elapsedTime * 0.8
    planets2Ref.current.rotation.y = -top * 0.005 - clock.elapsedTime * 0.6
    planets3Ref.current.rotation.y = -top * 0.005 - clock.elapsedTime * 0.4

    const z = Math.sin(clock.elapsedTime * 0.4) * 0.3
    planetsRef.current.rotation.z = z
    planets2Ref.current.rotation.z = -z
    // planets3Ref.current.rotation.z = z
  })
  
  return(
    <group ref={groupRef} {...props}>
      <RoundedGlass
        ref={glassRef}
        args={[3, 3, 3]}
        radius={0.2}
        smoothness={32}
        roughness={0}
        transmission={0.95}
        thickness={0.5}
      />
      <GeoBRLC ref={logoRef} />
      <group ref={planetsRef}>
        <PlanetOne position={[4,-1,0]} scale={[0.8,0.8,0.8]} />
      </group>
      <group ref={planets2Ref}>
        <PlanetTwo position={[-1.5,3,1.5]} scale={[0.8,0.8,0.8]} />
      </group>
      <group ref={planets3Ref}>
        <PlanetThree position={[1,-4,1]} scale={[1.5,1.5,1.5]} />
      </group>
    </group>
  )
}
